var map = {
	"./reshK.jpg": 220,
	"./reshetkaR.jpg": 221,
	"./sirene.jpg": 222,
	"./valchizab_cr.jpg": 223
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 219;


//////////////////
// WEBPACK FOOTER
// ./src/images/specialApplications nonrecursive \.(png|jpe?g|svg)$
// module id = 219
// module chunks = 0